export default __webpack_public_path__ + "static/media/ic_reliance.724cf709.png";